import type { Preferences } from "./Preferences"

export const DEFAULT_PREFERENCES: Preferences = {
  color: "dark",
  display: "cozy",
  fontSize: 16,
  confirmExit: false,
  expandSections: false,
}
